import React, { useState } from "react";
import "./DealerLabel.scss";
import { AspectRatio, isDevReact } from "../api/ReplayVariables";
import PlayerWindowPositions from "../api/PlayerWindowPositions";

function DealerLabel({ seats, seat, realTableRatio, top, left, onMove }) {
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  let dragging = false;

  const onDragStart = (evt) => {
    setStartPosition({ x: evt.screenX, y: evt.screenY });
    console.log("onDragStart", startPosition);
  };
  const onDrag = (evt) => {
    dragging = true;
    //console.log("drag", evt);
  };
  const onDragEnd = (evt) => {
    if (dragging) {
      //console.log("repositionedSeat", seat);

      let newPosition = { x: evt.screenX, y: evt.screenY };
      console.log("onDragEnd", newPosition);
      console.log("startPosition", startPosition);
      let diff = {
        x: Math.floor((newPosition.x - startPosition.x) / realTableRatio),
        y: Math.floor((newPosition.y - startPosition.y) / realTableRatio)
      };
      console.log("diff", diff);
      let newTop =
        PlayerWindowPositions[seats + "_" + seat + "_buttonTop"] + diff.y;
      let newLeft =
        PlayerWindowPositions[seats + "_" + seat + "_buttonLeft"] + diff.x;
      PlayerWindowPositions[seats + "_" + seat + "_buttonTop"] = newTop;
      PlayerWindowPositions[seats + "_" + seat + "_buttonLeft"] = newLeft;
      dragging = false;
      console.log(
        "PlayerWindowPositions[" +
          seats +
          "_" +
          seat +
          "_buttonTop" +
          "]:" +
          PlayerWindowPositions[seats + "_" + seat + "_buttonTop"]
      );
      console.log(
        "PlayerWindowPositions[" +
          seats +
          "_" +
          seat +
          "_buttonLeft" +
          "]:" +
          PlayerWindowPositions[seats + "_" + seat + "_buttonLeft"]
      );
      //console.log("diff", diff);
      //console.log(PlayerWindowPositions);
      onMove();
    }
  };

  return (
    <div
      draggable={isDevReact()}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDrag={onDrag}
      className="dealer"
      style={{
        top: Math.round(top) + "px",
        left: Math.round(left) + "px",
        /*
        width: AspectRatio.refPlayerWidth * realTableRatio + "px",
        */
        lineHeight:
          Math.round(AspectRatio.refLineHeight * realTableRatio) + "px",
        fontSize: Math.round(AspectRatio.refFontSize * realTableRatio) + "px"
      }}
    >
      &nbsp;&nbsp;D&nbsp;&nbsp;
    </div>
  );
}
export default DealerLabel;
